"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizes = void 0;
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.sizes = {
    xs: 570,
    sm: 770,
    md: 970,
    lg: 1170,
    xl: 1370,
};
exports.default = react_jss_1.createUseStyles({
    container: function (_a) {
        var fluid = _a.fluid, size = _a.size, padding = _a.padding, theme = _a.theme;
        return ({
            maxWidth: fluid ? '100%' : theme_1.getSizeValue({ size: size, sizes: exports.sizes }),
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingLeft: theme_1.getSizeValue({ size: padding, sizes: theme.spacing }),
            paddingRight: theme_1.getSizeValue({ size: padding, sizes: theme.spacing }),
        });
    },
}, { link: true });
